const CONNECTED_BRANDS_ENDPOINTS = {
  CONNECTED_BRANDS_HIDE: '/brands/hide_brands',
  CONNECTED_BRANDS_DISPLAY: '/brands/display_brands'
};

export default CONNECTED_BRANDS_ENDPOINTS;
